import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(site)/search/SearchClient.tsx");
